import { routes } from "../../config/routes";
import {
  PiFolder,
  PiStack,
  PiUsers,
  PiCheckFill,
  PiGear,
} from "react-icons/pi";
import { RiExchange2Fill } from "react-icons/ri";

// Note: do not add href in the label object, it is rendering as label
export const menuItems = [
  // label start
  {
    name: "Overview",
  },
  // label end
  {
    name: "Dashboard",
    href: "/",
    icon: <PiFolder />,
    badge: "",
  },
  // label start
  {
    name: "Users",
  },
  // label end
  {
    name: "Users",
    href: routes.userManagement.users,
    badge: "",
    icon: <PiUsers />,
  },
  {
    name: "Name Change",
    href: routes.userManagement.nameChange,
    badge: "",
    icon: <RiExchange2Fill />,
  },
  // {
  //   name: "Pending KYC",
  //   href: routes.userManagement.kyc,
  //   badge: "",
  //   icon: <PiJoystick />,
  // },

  {
    name: "Campaign",
  },

  {
    name: "Campaigns",
    href: routes.campaignManagement.campaigns,
    badge: "",
    icon: <PiStack />,
  },
  {
    name: "Campaigns Reports",
    href: routes.campaignManagement.reports,
    badge: "",
    icon: <PiStack />,
  },
  {
    name: "Payment Links",
  },

  {
    name: "All Payment Links",
    href: routes.campaignManagement.allPaymentLinks,
    badge: "",
    icon: <PiStack />,
  },
  {
    name: "All Payment Links Donations",
    href: routes.campaignManagement.allDonations,
    badge: "",
    icon: <PiStack />,
  },
  
  // {
  //   name: "Pending Campaigns",
  //   href: routes.campaignManagement.pending,
  //   badge: "",
  //   icon: <PiClockAfternoon />,
  // },
  // {
  //   name: "Flagged Campaigns",
  //   href: routes.campaignManagement.flagged,
  //   badge: "",
  //   icon: <PiFlagBannerFill />,
  // },
  {
    name: "Transactions & Payments",
  },
  {
    name: "Transactions",
    href: routes.transactions.transactions,
    badge: "",
    icon: <PiCheckFill />,
  },
  // {
  //   name: "Withdrawal Request",
  //   href: routes.transactions.withdrawalRequest,
  //   badge: "",
  //   icon: <PiHandWithdraw />,
  // },
  // {
  //   name: "Payment Settings",
  //   href: routes.transactions.settings.payments,
  //   badge: "",
  //     icon: <PiContactlessPayment />,
  // },
  {
    name: "Settings",
  },
  {
    name: "Fee Settings",
    href: routes.transactions.settings.fees,
    badge: "",
    icon: <PiGear />,
  },
  // {
  //   name: "Revenue",
  //   href: routes.transactions.revenue,
  //   badge: "",
  //   icon: <PiAlignRightFill />,
  // },

  // {
  //   name: "Reports & Analytics",
  // },
  // {
  //   name: "User Analytics",
  //   href: routes.reportAnalytics.userAnalytics,
  //   badge: "",
  //   icon: <PiChartBarDuotone />,
  // },
  // {
  //   name: "Campaign Performance Report",
  //   href: routes.reportAnalytics.campaignPerformanceReport,
  //   badge: "",
  //   icon: <PiChartLineBold />,
  // },
  // {
  //   name: "Withdrawal & Payment Logs",
  //   href: routes.reportAnalytics.withdrawalPaymentLog,
  //   badge: "",
  //   icon: <PiChartPieSliceFill />,
  // },
];
